import React, { useEffect } from 'react';

export interface FullScreenLoaderProps {
  visible: boolean;
  label?: string;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ visible, label = 'Loading...' }) => {
  useEffect(() => {
    if (!visible) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="bg-white rounded-2xl shadow-xl px-8 py-6 flex flex-col items-center gap-4">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-b-4 border-[#01545D]" />
        <div className="text-lg font-semibold text-[#01545D]">{label}</div>
      </div>
    </div>
  );
};

export default FullScreenLoader;
